import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import AnimatedMetric from "../../client/components/AnimatedMetric";
import LazyApexChart from '../../client/components/LazyApexChart';
import { useDashboardData } from "./DashboardDataContext";
import { chartColors } from "./chart/chartColors";

export default function WinRateWidget() {
  const { metrics, isDark, themeId, t } = useDashboardData();
  if (!metrics) return null;
  const c = chartColors();
  const breakEven = metrics.totalTrades > metrics.winningTrades + metrics.losingTrades
    ? metrics.totalTrades - metrics.winningTrades - metrics.losingTrades
    : 0;
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.tradeWinPct} isDark={isDark} compact />
      <CardContent className="px-4 pb-4 pt-2 flex-1 flex flex-col justify-center min-w-0">
        <div className="flex items-center gap-4 min-w-0">
          <div className="flex-1 min-w-0">
            <AnimatedMetric value={metrics.winRate} format="percent" suffix="%" className="block truncate text-xl sm:text-2xl font-bold font-mono tabular-nums" />
          </div>
          {/* Radial décoratif : masqué sur carte étroite, où les 90px fixes
              ne laisseraient plus la place d'afficher le pourcentage. */}
          <div className="hidden sm:flex flex-col items-center shrink-0" style={{ width: 90 }}>
            <div style={{ overflow: "hidden", height: 52 }}>
              <LazyApexChart
                key={`winrate-${themeId}-${metrics.winRate}`}
                options={{
                  chart: { type: "radialBar" as const, background: "transparent", sparkline: { enabled: true } },
                  plotOptions: {
                    radialBar: {
                      startAngle: -90,
                      endAngle: 90,
                      hollow: { size: "55%" },
                      track: { background: c.grid, strokeWidth: "100%" },
                      dataLabels: { show: false },
                    },
                  },
                  fill: { colors: [metrics.winRate >= 50 ? c.accent : c.negative] },
                  stroke: { lineCap: "round" as const },
                  tooltip: { enabled: false },
                }}
                series={[parseFloat(metrics.winRate.toFixed(1))]}
                type="radialBar"
                width={90}
                height={90}
              />
            </div>
          </div>
        </div>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="text-[10px] font-semibold text-primary">{metrics.winningTrades} W</span>
          <span className="text-[10px] text-muted-foreground">{breakEven} B</span>
          <span className="text-[10px] font-semibold text-destructive">{metrics.losingTrades} L</span>
        </div>
      </CardContent>
    </Card>
  );
}
